import type { ImgHTMLAttributes, SyntheticEvent } from 'react'

import { sectionPreviewUrl } from '../utils/sectionPreview'

/**
 * Картинка раздела в маленьком размере: грузит лёгкое превью (utils/sectionPreview), а если его нет или оно битое —
 * один раз откатывается на оригинал (без циклов).
 */
export default function PreviewImg({ src, onError, ...rest }: ImgHTMLAttributes<HTMLImageElement> & { src: string }) {
	const preview = sectionPreviewUrl(src)
	const fallback = (e: SyntheticEvent<HTMLImageElement, Event>) => {
		const img = e.currentTarget
		if (preview !== src && !img.dataset.fbk) {
			img.dataset.fbk = '1'
			img.src = src
			return
		}
		onError?.(e)
	}
	return <img {...rest} src={preview} onError={fallback} />
}
